import React from 'react';
import c from 'classnames';
import s from './FacetContent.scss';
const FacetContent = ({ size, className, children })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s[`size-${size}`], className)
    }, children);
};
FacetContent.displayName = 'FacetContent';
export default FacetContent;

//# sourceMappingURL=FacetContent.js.map